
import { BrowserRouter, useLocation } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ScrollToTop";
import SiteHeader from "./components/SiteHeader";
import SiteFooter from "./components/SiteFooter";

function PageContent() {
  const { pathname } = useLocation();
  return (
    <main key={pathname} className="page-enter">
      <AppRoutes />
    </main>
  );
}

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <SiteHeader />
        <PageContent />
        <SiteFooter />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
